var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import * as React from 'react';
import { NaviError } from 'navi';
import { NavContext } from './NavContext';

var NavProvider =
/** @class */
function (_super) {
  __extends(NavProvider, _super);

  function NavProvider(props) {
    var _this = _super.call(this, props) || this;

    _this.handleNavigationSnapshot = function (navigationSnapshot) {
      _this.setState({
        navigationSnapshot: navigationSnapshot
      });
    };

    _this.handleError = function (error) {
      throw error;
    };

    _this.state = {};
    return _this;
  }

  NavProvider.getDerivedStateFromProps = function (props, state) {
    if (props.navigationSnapshot) {
      return {
        navigationSnapshot: undefined
      };
    } else if (!state.navigationSnapshot) {
      if (!props.navigation) {
        throw new MissingNavigationError();
      }

      return {
        navigationSnapshot: props.navigation.getCurrentValue()
      };
    } else {
      return null;
    }
  };

  NavProvider.prototype.render = function () {
    if (process.env.NODE_ENV !== 'production') {
      if (this.props.navigationSnapshot && this.props.navigation) {
        console.warn("A <Navi.Provider> component has received values for both its \"navigation\" and \"navigationSnapshot\" props. Navi will use the \"navigationSnapshot\" value.");
      }
    }

    return React.createElement(NavContext.Provider, {
      value: this.props.navigationSnapshot || this.state.navigationSnapshot
    }, this.props.children);
  };

  NavProvider.prototype.componentDidMount = function () {
    if (!this.props.navigationSnapshot) {
      this.subscribe();
    }
  };

  NavProvider.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.navigationSnapshot && !this.props.navigationSnapshot) {
      this.subscribe();
    } else if (!prevProps.navigationSnapshot && this.props.navigationSnapshot) {
      this.unsubscribe();
    }
  };

  NavProvider.prototype.componentWillUnmount = function () {
    this.unsubscribe();
  };

  NavProvider.prototype.subscribe = function () {
    if (!this.props.navigation) {
      throw new MissingNavigationError();
    }

    this.subscription = this.props.navigation.subscribe(this.handleNavigationSnapshot, this.handleError);
  };

  NavProvider.prototype.unsubscribe = function () {
    if (this.subscription) {
      this.subscription.unsubscribe();
      delete this.subscription;
    }
  };

  return NavProvider;
}(React.Component);

export { NavProvider };

var MissingNavigationError =
/** @class */
function (_super) {
  __extends(MissingNavigationError, _super);

  function MissingNavigationError() {
    return _super.call(this, "A <NavProvider> component must receive a \"navigation\" or \"navigationSnapshot\" prop.") || this;
  }

  return MissingNavigationError;
}(NaviError);

export { MissingNavigationError };